/*usage*/
/*upgrading-turborepo-versions*/
/*turborepo-2x*/
/*turborepo-1x*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "@turbo/codemod",
  "description": "了解更多关于 Turborepo 如何使用 codemods 简化版本迁移的信息。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 提供 codemod 转换和自动迁移脚本，以便在某个功能弃用时帮助你升级 Turborepo 代码库。"
  }, {
    "heading": "",
    "content": "¥Turborepo provides codemod transformations and automatic migration scripts to help upgrade your Turborepo codebase when a feature is deprecated."
  }, {
    "heading": "",
    "content": "Codemod 是以编程方式在代码库上运行的转换。这允许应用大量更改，而无需手动管理重复更改。"
  }, {
    "heading": "",
    "content": "¥Codemods are transformations that run on your codebase programmatically. This allows for a large amount of changes to be applied without having to manually manage repetitive changes."
  }, {
    "heading": "用法-usage",
    "content": "¥Usage"
  }, {
    "heading": "用法-usage",
    "content": "首先，确保你已经运行了包管理器的安装命令。"
  }, {
    "heading": "用法-usage",
    "content": "¥First, ensure that you've run your package manager's install command."
  }, {
    "heading": "用法-usage",
    "content": "transform - 转换名称，请参阅下文可用的转换。"
  }, {
    "heading": "用法-usage",
    "content": "¥transform - name of transform, see available transforms below."
  }, {
    "heading": "用法-usage",
    "content": "path - 要转换的文件或目录"
  }, {
    "heading": "用法-usage",
    "content": "¥path - files or directory to transform"
  }, {
    "heading": "用法-usage",
    "content": "--dry - 进行试运行（代码不会被编辑）"
  }, {
    "heading": "用法-usage",
    "content": "¥--dry - Do a dry-run (Code will not be edited)"
  }, {
    "heading": "用法-usage",
    "content": "--print - 打印更改后的输出以供比较"
  }, {
    "heading": "用法-usage",
    "content": "¥--print - Prints the changed output for comparison"
  }, {
    "heading": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "¥Upgrading Turborepo versions"
  }, {
    "heading": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "在大多数情况下，你可以运行："
  }, {
    "heading": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "¥In most cases, you can run:"
  }, {
    "heading": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "所有升级所需的 codemod 都将为你运行。"
  }, {
    "heading": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "¥All the codemods you need to upgrade will be run for you."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "以下 codemod 用于 Turborepo 第二个主要版本中的迁移路径。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥The codemods below are used for migration paths in the second major version of Turborepo."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "将版本化的 schema.json URL 更新为 v2。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Updates a versioned schema.json URL to v2."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "在任何没有名称的包中为 package.json 添加名称。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Adds a name to package.json in any packages that don't have one."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "修复由于 turbo 中 glob 处理方式的更改而导致无效的 glob 模式。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Fix glob patterns that are invalid due to changes in processing of globs in turbo."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "将 .env 文件从已删除的 dotEnv 键移动到 inputs。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Move .env files from the removed dotEnv key to inputs."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "将 outputMode 键重命名为 outputLogs。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Rename the outputMode key to outputLogs."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "将 pipeline 键重命名为 tasks。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Rename the pipeline key to tasks."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "将 turbo.json 中的 experimentalUI 键重命名为 ui。"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Renames the experimentalUI key in turbo.json to ui."
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "示例"
  }, {
    "heading": "turborepo-2x-turborepo-2x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "以下 codemod 用于 Turborepo 第一个主要版本中的迁移路径。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥The codemods below are used for migration paths in the first major version of Turborepo."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "将 turbo.json 的 experimentalGlobalPassThroughEnv 迁移到 globalPassThroughEnv，将 experimentalPassThroughEnv 迁移到 passThroughEnv。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Migrates turbo.json's experimentalGlobalPassThroughEnv to globalPassThroughEnv and experimentalPassThroughEnv to passThroughEnv."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "更新任何内容对新通配符语法不明确的现有环境变量字段。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Updates any existing environment variable fields whose contents would be ambiguous to the new wildcard syntax."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "迁移 turbo.json 的输出以包含先前推断的 dist/** 和 build/**。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Migrates turbo.json outputs to include the previously inferred dist/** and build/**."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "将 turbo.json 中的所有环境变量依赖分别从 dependsOn 和 globalDependencies 迁移到 env 和 globalEnv。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Migrates all environment variable dependencies in turbo.json from dependsOn and globalDependencies to env and globalEnv respectively."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "转换根 package.json，使 packageManager 键作为检测到的包管理器（yarn、npm、pnpm）和版本（例如 yarn@1.22.17）。此键现在为 Node.js 支持，Turborepo 使用它来更快地检测包管理器（而不是仅从文件系统推断）。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Transforms the root package.json so that packageManager key as the detected package manager (yarn, npm, pnpm) and version (e.g. yarn@1.22.17). This key is now supported by Node.js and is used by Turborepo for faster package manager detection (vs. inferring from just the filesystem alone)."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "根据 package.json 中的 \"turbo\" 键，在项目根目录下创建 turbo.json 文件。\"turbo\" 键随后会从 package.json 中删除。"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Creates the turbo.json file at the root of your project based on the \"turbo\" key in package.json.\nThe \"turbo\" key is subsequently deleted from package.json."
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "示例"
  }, {
    "heading": "turborepo-1x-turborepo-1x",
    "content": "¥Example"
  }],
  "headings": [{
    "id": "用法-usage",
    "content": "用法 /*usage*/"
  }, {
    "id": "升级-turborepo-版本-upgrading-turborepo-versions",
    "content": "升级 Turborepo 版本 /*upgrading-turborepo-versions*/"
  }, {
    "id": "turborepo-2x-turborepo-2x",
    "content": "Turborepo 2.x /*turborepo-2x*/"
  }, {
    "id": "turborepo-1x-turborepo-1x",
    "content": "Turborepo 1.x /*turborepo-1x*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {Callout} from '#components/callout';
import {Accordion, Accordions} from '#components/accordion';
export const toc = [{
  depth: 2,
  url: "#用法-usage",
  title: _jsx(_Fragment, {
    children: "用法 "
  })
}, {
  depth: 2,
  url: "#升级-turborepo-版本-upgrading-turborepo-versions",
  title: _jsx(_Fragment, {
    children: "升级 Turborepo 版本 "
  })
}, {
  depth: 3,
  url: "#turborepo-2x-turborepo-2x",
  title: _jsx(_Fragment, {
    children: "Turborepo 2.x "
  })
}, {
  depth: 3,
  url: "#turborepo-1x-turborepo-1x",
  title: _jsx(_Fragment, {
    children: "Turborepo 1.x "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo 提供 codemod 转换和自动迁移脚本，以便在某个功能弃用时帮助你升级 Turborepo 代码库。"
    }), "\n", _jsx(_components.p, {
      children: "¥Turborepo provides codemod transformations and automatic migration scripts to help upgrade your Turborepo codebase when a feature is deprecated."
    }), "\n", _jsx(_components.p, {
      children: "Codemod 是以编程方式在代码库上运行的转换。这允许应用大量更改，而无需手动管理重复更改。"
    }), "\n", _jsx(_components.p, {
      children: "¥Codemods are transformations that run on your codebase programmatically. This allows for a large amount of changes to be applied without having to manually manage repetitive changes."
    }), "\n", _jsx(_components.h2, {
      id: "用法-usage",
      children: "用法 "
    }), "\n", _jsx(_components.p, {
      children: "¥Usage"
    }), "\n", _jsx(_components.p, {
      children: "首先，确保你已经运行了包管理器的安装命令。"
    }), "\n", _jsx(_components.p, {
      children: "¥First, ensure that you've run your package manager's install command."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [transform] [path] [--dry] [--print]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "transform"
          }), " - 转换名称，请参阅下文可用的转换。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "transform"
          }), " - name of transform, see available transforms below."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "path"
          }), " - 要转换的文件或目录"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "path"
          }), " - files or directory to transform"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "--dry"
          }), " - 进行试运行（代码不会被编辑）"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "--dry"
          }), " - Do a dry-run (Code will not be edited)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "--print"
          }), " - 打印更改后的输出以供比较"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "--print"
          }), " - Prints the changed output for comparison"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "升级-turborepo-版本-upgrading-turborepo-versions",
      children: "升级 Turborepo 版本 "
    }), "\n", _jsx(_components.p, {
      children: "¥Upgrading Turborepo versions"
    }), "\n", _jsx(_components.p, {
      children: "在大多数情况下，你可以运行："
    }), "\n", _jsx(_components.p, {
      children: "¥In most cases, you can run:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "所有升级所需的 codemod 都将为你运行。"
    }), "\n", _jsx(_components.p, {
      children: "¥All the codemods you need to upgrade will be run for you."
    }), "\n", _jsx(_components.h3, {
      id: "turborepo-2x-turborepo-2x",
      children: "Turborepo 2.x "
    }), "\n", _jsx(_components.p, {
      children: "以下 codemod 用于 Turborepo 第二个主要版本中的迁移路径。"
    }), "\n", _jsx(_components.p, {
      children: "¥The codemods below are used for migration paths in the second major version of Turborepo."
    }), "\n", _jsxs(Accordions, {
      children: [_jsxs(Accordion, {
        title: "update-schema-json-url (2.0.0)",
        id: "update-schema-json-url",
        children: [_jsx(_components.p, {
          children: "将版本化的 schema.json URL 更新为 v2。"
        }), _jsx(_components.p, {
          children: "¥Updates a versioned schema.json URL to v2."
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " update-schema-json-url"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"$schema\": \"https://turbo.nodejs.cn/schema.v1.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"$schema\": \"https://turbo.nodejs.cn/schema.v2.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "add-package-names (2.0.0)",
        id: "add-package-names",
        children: [_jsxs(_components.p, {
          children: ["在任何没有名称的包中为 ", _jsx(_components.code, {
            children: "package.json"
          }), " 添加名称。"]
        }), _jsxs(_components.p, {
          children: ["¥Adds a name to ", _jsx(_components.code, {
            children: "package.json"
          }), " in any packages that don't have one."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add-package-names"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/ui/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"name\": \"@repo/ui\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "clean-globs (2.0.0)",
        id: "clean-globs",
        children: [_jsxs(_components.p, {
          children: ["修复由于 ", _jsx(_components.code, {
            children: "turbo"
          }), " 中 glob 处理方式的更改而导致无效的 glob 模式。"]
        }), _jsxs(_components.p, {
          children: ["¥Fix glob patterns that are invalid due to changes in processing of globs in ", _jsx(_components.code, {
            children: "turbo"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " clean-globs"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"outputs\": ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        // Collapse back-to-back doublestars"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-         \"**/**.ext\", // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+         \"**.ext\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        // Ensure a file extension does not have a double-star"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-         \"**.ext\", // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+         \"**/*.ext\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        // Proper expansion of directory names"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-         \"prefix**/\", // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+         \"prefix*/**\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "migrate-dot-env (2.0.0)",
        id: "migrate-dot-env",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: ".env"
          }), " 文件从已删除的 ", _jsx(_components.code, {
            children: "dotEnv"
          }), " 键移动到 ", _jsx(_components.code, {
            children: "inputs"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Move ", _jsx(_components.code, {
            children: ".env"
          }), " files from the removed ", _jsx(_components.code, {
            children: "dotEnv"
          }), " key to ", _jsx(_components.code, {
            children: "inputs"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate-dot-env"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-       \"dotEnv\": [\".env\"], // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"inputs\": ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "        \"dist/**\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+         \".env\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "rename-output-mode (2.0.0)",
        id: "rename-output-mode",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "outputMode"
          }), " 键重命名为 ", _jsx(_components.code, {
            children: "outputLogs"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Rename the ", _jsx(_components.code, {
            children: "outputMode"
          }), " key to ", _jsx(_components.code, {
            children: "outputLogs"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " rename-output-mode"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"outputMode\": \"errors-only\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"outputLogs\": \"errors-only\" // [!code highlight]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "rename-pipeline (2.0.0)",
        id: "rename-pipeline",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "pipeline"
          }), " 键重命名为 ", _jsx(_components.code, {
            children: "tasks"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Rename the ", _jsx(_components.code, {
            children: "pipeline"
          }), " key to ", _jsx(_components.code, {
            children: "tasks"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " rename-pipeline"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"pipeline\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"tasks\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ..."
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    },"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"dev\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ..."
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    },"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"lint\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ..."
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "stabilize-ui (2.0.0)",
        id: "stabilize-ui",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "experimentalUI"
          }), " 键重命名为 ", _jsx(_components.code, {
            children: "ui"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Renames the ", _jsx(_components.code, {
            children: "experimentalUI"
          }), " key in ", _jsx(_components.code, {
            children: "turbo.json"
          }), " to ", _jsx(_components.code, {
            children: "ui"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " stabilize-ui"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"experimentalUI\": true"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"ui\": true"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "turborepo-1x-turborepo-1x",
      children: "Turborepo 1.x "
    }), "\n", _jsx(_components.p, {
      children: "以下 codemod 用于 Turborepo 第一个主要版本中的迁移路径。"
    }), "\n", _jsx(_components.p, {
      children: "¥The codemods below are used for migration paths in the first major version of Turborepo."
    }), "\n", _jsxs(Accordions, {
      children: [_jsxs(Accordion, {
        title: "stabilize-env-mode (1.10.0)",
        id: "stabilize-env-mode",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 的 ", _jsx(_components.code, {
            children: "experimentalGlobalPassThroughEnv"
          }), " 迁移到 ", _jsx(_components.code, {
            children: "globalPassThroughEnv"
          }), "，将 ", _jsx(_components.code, {
            children: "experimentalPassThroughEnv"
          }), " 迁移到 ", _jsx(_components.code, {
            children: "passThroughEnv"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Migrates ", _jsx(_components.code, {
            children: "turbo.json"
          }), "'s ", _jsx(_components.code, {
            children: "experimentalGlobalPassThroughEnv"
          }), " to ", _jsx(_components.code, {
            children: "globalPassThroughEnv"
          }), " and ", _jsx(_components.code, {
            children: "experimentalPassThroughEnv"
          }), " to ", _jsx(_components.code, {
            children: "passThroughEnv"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " stabilize-env-mode"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"$schema\": \"https://turbo.nodejs.cn/schema.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"experimentalGlobalPassThroughEnv\": [\"CC\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"globalPassThroughEnv\": [\"CC\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"pipeline\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"experimentalPassThroughEnv\": [\"GOROOT\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"passThroughEnv\": [\"GOROOT\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "transform-env-literals-to-wildcards (1.10.0)",
        id: "transform-env-literals-to-wildcards",
        children: [_jsx(_components.p, {
          children: "更新任何内容对新通配符语法不明确的现有环境变量字段。"
        }), _jsx(_components.p, {
          children: "¥Updates any existing environment variable fields whose contents would be ambiguous to the new wildcard syntax."
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " transform-env-literals-to-wildcards"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"$schema\": \"https://turbo.nodejs.cn/schema.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"globalEnv\": [\"THIS_*_IS_LITERAL\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"globalPassThroughEnv\": [\"!LITERAL_LEADING_EXCLAMATION\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+  \"globalEnv\": [\"THIS_\\\\*_IS_LITERAL\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+  \"globalPassThroughEnv\": [\"\\\\!LITERAL_LEADING_EXCLAMATION\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"pipeline\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"env\": [\"50_PERCENT_OFF*_HAS_SMALL_PRINT\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"passThroughEnv\": [\"**BOLDED**\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"env\": [\"50_PERCENT_OFF\\\\*_HAS_SMALL_PRINT\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"passThroughEnv\": [\"\\\\*\\\\*BOLDED\\\\*\\\\*\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "set-default-outputs (1.7.0)",
        id: "set-default-outputs",
        children: [_jsxs(_components.p, {
          children: ["迁移 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 的输出以包含先前推断的 ", _jsx(_components.code, {
            children: "dist/**"
          }), " 和 ", _jsx(_components.code, {
            children: "build/**"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Migrates ", _jsx(_components.code, {
            children: "turbo.json"
          }), " outputs to include the previously inferred ", _jsx(_components.code, {
            children: "dist/**"
          }), " and ", _jsx(_components.code, {
            children: "build/**"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " set-default-outputs"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"$schema\": \"https://turbo.nodejs.cn/schema.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"globalDependencies\": [\".env\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"globalEnv\": [\"CI_ENV\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"pipeline\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"dependsOn\": [\"^build\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"env\": [\"API_BASE\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"outputs\": [\".next/**\", \"!.next/cache/**\"]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    },"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-   \"lint\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"outputs\": []"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-    },"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+   \"lint\": {},"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"dev\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"cache\": false,"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"persistent\": true,"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"outputs\": [\"dist/**\", \"build/**\"]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "migrate-env-var-dependencies (1.5.0)",
        id: "migrate-env-var-dependencies",
        children: [_jsxs(_components.p, {
          children: ["将 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 中的所有环境变量依赖分别从 ", _jsx(_components.code, {
            children: "dependsOn"
          }), " 和 ", _jsx(_components.code, {
            children: "globalDependencies"
          }), " 迁移到 ", _jsx(_components.code, {
            children: "env"
          }), " 和 ", _jsx(_components.code, {
            children: "globalEnv"
          }), "。"]
        }), _jsxs(_components.p, {
          children: ["¥Migrates all environment variable dependencies in ", _jsx(_components.code, {
            children: "turbo.json"
          }), " from ", _jsx(_components.code, {
            children: "dependsOn"
          }), " and ", _jsx(_components.code, {
            children: "globalDependencies"
          }), " to ", _jsx(_components.code, {
            children: "env"
          }), " and ", _jsx(_components.code, {
            children: "globalEnv"
          }), " respectively."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " migrate-env-var-dependencies"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "// After, turbo.json"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"$schema\": \"https://turbo.nodejs.cn/schema.json\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "- \"globalDependencies\": [\".env\", \"$CI_ENV\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"globalDependencies\": [\".env\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+ \"globalEnv\": [\"CI_ENV\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"pipeline\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"build\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-deleted)",
                    "--shiki-dark": "var(--shiki-token-deleted)"
                  },
                  children: "-     \"dependsOn\": [\"^build\", \"$API_BASE\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"dependsOn\": [\"^build\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+     \"env\": [\"API_BASE\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"outputs\": [\".next/**\", \"!.next/cache/**\"],"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    },"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"lint\": {},"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"dev\": {"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"cache\": false,"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      \"persistent\": true"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "add-package-manager (1.1.0)",
        id: "add-package-manager",
        children: [_jsxs(_components.p, {
          children: ["转换根 ", _jsx(_components.code, {
            children: "package.json"
          }), "，使 ", _jsx(_components.code, {
            children: "packageManager"
          }), " 键作为检测到的包管理器（", _jsx(_components.code, {
            children: "yarn"
          }), "、", _jsx(_components.code, {
            children: "npm"
          }), "、", _jsx(_components.code, {
            children: "pnpm"
          }), "）和版本（例如 ", _jsx(_components.code, {
            children: "yarn@1.22.17"
          }), "）。此键现在为 ", _jsx(_components.a, {
            href: "https://nodejs.cn/dist/latest-v17.x/docs/api/packages.html#packagemanager",
            children: "Node.js 支持"
          }), "，Turborepo 使用它来更快地检测包管理器（而不是仅从文件系统推断）。"]
        }), _jsxs(_components.p, {
          children: ["¥Transforms the root ", _jsx(_components.code, {
            children: "package.json"
          }), " so that ", _jsx(_components.code, {
            children: "packageManager"
          }), " key as the detected package manager (", _jsx(_components.code, {
            children: "yarn"
          }), ", ", _jsx(_components.code, {
            children: "npm"
          }), ", ", _jsx(_components.code, {
            children: "pnpm"
          }), ") and version (e.g. ", _jsx(_components.code, {
            children: "yarn@1.22.17"
          }), "). This key is now ", _jsx(_components.a, {
            href: "https://nodejs.cn/dist/latest-v17.x/docs/api/packages.html#packagemanager",
            children: "supported by Node.js"
          }), " and is used by Turborepo for faster package manager detection (vs. inferring from just the filesystem alone)."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add-package-manager"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"name\": \"turborepo-basic\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"version\": \"0.0.0\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"private\": true,"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-inserted)",
                    "--shiki-dark": "var(--shiki-token-inserted)"
                  },
                  children: "+  \"packageManager\": \"yarn@1.22.17\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  \"workspaces\": ["
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"apps/*\","
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    \"packages/*\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  ]"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "create-turbo-config (1.1.0)",
        id: "create-turbo-config",
        children: [_jsxs(_components.p, {
          children: ["根据 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中的 ", _jsx(_components.code, {
            children: "\"turbo\""
          }), " 键，在项目根目录下创建 ", _jsx(_components.code, {
            children: "turbo.json"
          }), " 文件。", _jsx(_components.code, {
            children: "\"turbo\""
          }), " 键随后会从 ", _jsx(_components.code, {
            children: "package.json"
          }), " 中删除。"]
        }), _jsxs(_components.p, {
          children: ["¥Creates the ", _jsx(_components.code, {
            children: "turbo.json"
          }), " file at the root of your project based on the ", _jsx(_components.code, {
            children: "\"turbo\""
          }), " key in ", _jsx(_components.code, {
            children: "package.json"
          }), ".\nThe ", _jsx(_components.code, {
            children: "\"turbo\""
          }), " key is subsequently deleted from ", _jsx(_components.code, {
            children: "package.json"
          }), "."]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @turbo/codemod"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo-config"
                })]
              })
            })
          })
        }), _jsx(_components.p, {
          children: _jsx(_components.strong, {
            children: "示例"
          })
        }), _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Example"
          })]
        }), _jsxs(Tabs, {
          items: ["package.json", "turbo.json"],
          children: [_jsx(Tab, {
            value: "package.json",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./package.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "// After, package.json"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "{"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"name\": \"@acme/workspace\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "  \"private\": true,"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-deleted)",
                        "--shiki-dark": "var(--shiki-token-deleted)"
                      },
                      children: "- \"turbo\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-deleted)",
                        "--shiki-dark": "var(--shiki-token-deleted)"
                      },
                      children: "-   \"pipeline\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-deleted)",
                        "--shiki-dark": "var(--shiki-token-deleted)"
                      },
                      children: "-     ..."
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-deleted)",
                        "--shiki-dark": "var(--shiki-token-deleted)"
                      },
                      children: "-   }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-deleted)",
                        "--shiki-dark": "var(--shiki-token-deleted)"
                      },
                      children: "- },"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-foreground)",
                        "--shiki-dark": "var(--shiki-foreground)"
                      },
                      children: "}"
                    })
                  })]
                })
              })
            })
          }), _jsx(Tab, {
            value: "turbo.json",
            children: _jsx(_Fragment, {
              children: _jsx(_components.pre, {
                className: "shiki shiki-themes css-variables css-variables",
                style: {
                  "--shiki-light": "var(--shiki-foreground)",
                  "--shiki-dark": "var(--shiki-foreground)",
                  "--shiki-light-bg": "var(--shiki-background)",
                  "--shiki-dark-bg": "var(--shiki-background)"
                },
                tabIndex: "0",
                title: "./turbo.json",
                icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
                children: _jsxs(_components.code, {
                  children: [_jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"$schema\": \"https://turbo.nodejs.cn/schema.json\","
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   \"pipeline\": {"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+     ..."
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+   }"
                    })
                  }), "\n", _jsx(_components.span, {
                    className: "line",
                    children: _jsx(_components.span, {
                      style: {
                        "--shiki-light": "var(--shiki-token-inserted)",
                        "--shiki-dark": "var(--shiki-token-inserted)"
                      },
                      children: "+ }"
                    })
                  })]
                })
              })
            })
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
